import { Fragment, useEffect, useState } from 'react';
import { PhoneForm } from '../../forms/phone-form/phone-form';
import styles from './sign-up.module.scss';
import { ecommerce, EcommerceAction } from '../../../services/ecommerce.service';
import { SceneToken } from '../../../enums/scene-token.enum';
import { PhoneFormData } from '../../../interfaces/phone-form-data.interface';
import { PopupWindow } from '../popup-window/popup-window';
import { PopupWindowMode } from '../../../enums/popup-window-mode.enum';
import ReactMarkDown from 'react-markdown';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { displayPopupWindow } from '../../../redux/display-slice';
import { analyticsService } from '../../../analytics.service';
import { AnalyticsEvent } from '../../../enums/analytics-event.enum';
import { useCreateLead } from '../../../hooks/leads.hook';
import { QuizHistoryService, browserHistoryService } from '../../../services/history.service';
import { BrowserHistoryCommand } from '../../../enums/browser-history-command.enum';
import { ISignupForm } from '../../../interfaces/sign-up-form.interface';

interface SignUpProps {
  historyService: QuizHistoryService
  content: ISignupForm,
  privacyPolicyUrl: string;
  onClose?: () => void;
}

const productInfo = {
  id: 'signup_form',
  name: 'Попап записи на прием',
};

export default function SignUp(props:SignUpProps) {
	const dispatch = useDispatch();
	const { content, historyService, privacyPolicyUrl, onClose } = props;
  const status = Boolean(historyService.currentScene.status);
  const createLead = useCreateLead();
  const screenWidth768 = useMediaQuery({ minWidth: 768});
  const mode = screenWidth768 ? PopupWindowMode.DEFAULT : PopupWindowMode.BOTTOM;
  const currentSceneStatus = Boolean(historyService.currentScene.status);
  const [scaleSettings, setScaleSettings ] = useState<{ screen: number, scale: number }[]>(null);
  
  useEffect(() => {
    if (content.view == "variants") {
      setScaleSettings([{ screen: 1024, scale: .9 }, { screen: 1600, scale: 1 }]);
    }
  }, [content.view]);

	useEffect(() => {
    analyticsService.send(AnalyticsEvent.REACH_PHONE_FORM, { form: 'sign-up' });
    analyticsService.send(AnalyticsEvent.OPEN_SING_UP);
  }, []);

  useEffect(() => {
    ecommerce.add(EcommerceAction.REVIEW, productInfo);
  }, []);

	return (
    <PopupWindow 
      active={currentSceneStatus} 
      mode={mode} 
      scaleSettings={scaleSettings}
      onClose={onClose} 
      showCloseButton={true}
    >
      <section className={styles[content.view]}>
        <h2 className={styles.header}>
          <ReactMarkDown
            source={content.header}
            escapeHtml={false}
            renderers={{ paragraph: props => <Fragment children={props.children} /> }}
          />
        </h2>
        <ReactMarkDown
          source={content.description}
          className={styles.description}
          escapeHtml={false}
          renderers={{ paragraph: props => <Fragment children={props.children} /> }}
        />
        <PhoneForm
          active={status} 
          onSubmit={submit} 
          button={content.buttonText} 
          mode={"sign-up"}
          fields={content.fields}
          formViewType={content.view || "default"}
          privacyPolicyUrl={privacyPolicyUrl}
          phoneField={content.phoneField}
        />
      </section>
    </PopupWindow>
	);

	async function submit({ phone, agreement, ...extraFields }: PhoneFormData) {
    const leadId = await createLead({ phone, extra: { form_type: 'phone', ...extraFields } });
    dispatch(displayPopupWindow(false));
    historyService.replace({token: SceneToken.FINAL });
    browserHistoryService.perform(BrowserHistoryCommand.REPLACE, { token: SceneToken.FINAL });
    ecommerce.add(EcommerceAction.CART, productInfo);
    if (leadId) ecommerce.purchase(leadId);
	}
}
